import { SemanticCOLORS } from "semantic-ui-react";
import { ECertStatus } from "../models/ICert";

type TCertStatusColors = {
    [key in ECertStatus]: SemanticCOLORS;
}

export const CertStatusColors: TCertStatusColors = {
    [ECertStatus.Valid]: "green",
    [ECertStatus.NotValid]: "red",
    [ECertStatus.ValidationFailed]: "black",
    [ECertStatus.Expires]: "yellow",
};
